import { Link } from "react-router-dom";
import { hotList } from "@/mocks/hotlist";
import { seriesList } from "@/mocks/series";

export default function TodayBoard() {
  const focus = seriesList[1];
  const trendIcon = { up: "ri-arrow-up-line", down: "ri-arrow-down-line", new: "ri-sparkling-2-line" };
  const trendTone = { up: "text-accent-500", down: "text-secondary-600", new: "text-primary-500" };

  return (
    <section className="mx-auto max-w-container px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        {/* 今日聚焦 */}
        <div className="lg:col-span-7">
          <div className="flex items-end justify-between">
            <div>
              <span className="text-xs font-semibold uppercase tracking-widest text-accent-600">今日聚焦</span>
              <h2 className="mt-2 text-2xl text-foreground-950 md:text-3xl">今天最值得跟进的瓜</h2>
            </div>
            <Link to="/duibi" className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 sm:flex">
              更多对比 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <Link
            to={`/shijian/${focus.slug}`}
            className="group mt-6 flex flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:border-primary-300 sm:flex-row"
          >
            <div className="relative h-52 w-full shrink-0 overflow-hidden sm:h-auto sm:w-2/5">
              <img src={focus.cover} alt={`${focus.title}焦点封面`} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
              <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">持续跟进</span>
            </div>
            <div className="flex flex-1 flex-col p-6">
              <span className="text-xs text-foreground-500">{focus.period} · {focus.category}</span>
              <h3 className="mt-2 text-xl font-semibold leading-snug text-foreground-950 transition group-hover:text-primary-600">
                {focus.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-6 text-foreground-600">{focus.summary.slice(0, 60)}…</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-film-line"></i> 已更新 {focus.episodes.length} 个节点
                </span>
                <span className="flex items-center gap-1 font-medium text-primary-600">
                  进入时间线 <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
                </span>
              </div>
            </div>
          </Link>
        </div>

        {/* 今日热榜 */}
        <div className="lg:col-span-5">
          <div className="flex h-full flex-col rounded-3xl border border-background-200 bg-background-50 p-6">
            <div className="flex items-center justify-between">
              <h2 className="text-xl text-foreground-950">今日热榜</h2>
              <span className="flex items-center gap-1.5 text-xs text-accent-500">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-60"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
                </span>
                实时更新
              </span>
            </div>
            <ol className="mt-4 flex-1 space-y-1">
              {hotList.map((h) => (
                <li key={h.rank}>
                  <a href="#series" className="group flex items-center gap-3 rounded-xl px-2 py-2.5 transition hover:bg-background-100">
                    <span
                      className={`w-6 shrink-0 text-center font-display text-base ${
                        h.rank <= 3 ? "text-primary-600" : "text-foreground-400"
                      }`}
                    >
                      {h.rank}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm text-foreground-800 group-hover:text-primary-700">{h.title}</span>
                      <span className="mt-0.5 flex items-center gap-2 text-xs text-foreground-400">
                        <span className="rounded bg-background-200 px-1.5 py-px">{h.tag}</span>
                        <span className="flex items-center gap-0.5">
                          <i className={`${trendIcon[h.trend]} ${trendTone[h.trend]}`}></i>
                          {h.heat}
                        </span>
                      </span>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
            <Link to="/pandian" className="mt-3 block rounded-full bg-primary-50 py-2.5 text-center text-sm text-primary-700 transition hover:bg-primary-100">
              去同类盘点深挖 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}